import React, { useState, useRef, useEffect } from "react";
import { func, string, bool, object, array } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import HamburgerIcon from "../../../atoms/icons/hamburger";
import SearchIcon from "../../../atoms/icons/search-icon";
import NavbarSearch from "../NavbarSearch";
import DesktopLogo from "../../../atoms/DesktopLogo";
import Navbar from "../Navbar";
import Headroom from "./Headroomindex";

import { logoRenderer, useDeviceWidth } from "../../../utils/react-utils";
import { micrositeStyles } from "./header-utils";
import { setDateParams } from "../../../helper/actions";

import "./staticHeader.m.css";

const StaticHeader = ({
  toggleVerticalMenubar,
  isVerticalMenubar,
  publisherAttributes,
  domainMenuItemsObj,
  location,
  domainSlug,
  pageType,
  socialLinks,
  customSocialLinks,
  setDateParams,
}) => {
  const [isDesktop, setIsDesktop] = useState(false);
  const [domainStyle, setDomainStyle] = useState({});
  const [showSearchIcon, setShowSearchIcon] = useState(true);
  const [sticky, setSticky] = useState(false);
  const ref = useRef(null);
  const scrollRef = useRef(null);

  useDeviceWidth(setIsDesktop);

  useEffect(() => {
    if (domainSlug) {
      setDomainData(domainSlug);
    }
  }, [domainSlug]);

  const setDomainData = (domainName) => {
    setDomainStyle(micrositeStyles[domainName] || {});
  };

  useEffect(() => {
    const handleScroll = () => {
      const navbarTopDistance = Math.abs(scrollRef.current.getBoundingClientRect().top);
      navbarTopDistance < 107 ? setSticky(false) : setSticky(true);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.addEventListener("scroll", handleScroll);
  }, []);

  const handleClickOutside = (event) => {
    if (ref.current && !ref.current.contains(event.target)) {
      setShowSearchIcon(true);
    }
  };

  useEffect(() => {
    !showSearchIcon && toggleSearchIcon();
  }, [sticky]);

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, true);
    document.addEventListener("scroll", () => setShowSearchIcon(true));
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
      document.removeEventListener("scroll", () => setShowSearchIcon(true));
      !showSearchIcon && toggleSearchIcon();
    };
  });

  const toggleSearchIcon = () => setShowSearchIcon(!showSearchIcon);

  const menuItemsObject =
    domainMenuItemsObj.length > 0
      ? {
          homePageMenuItems: domainMenuItemsObj.find((item) => item.title === "home" || item.title === "Home"),
          hamburgerMenuItems: domainMenuItemsObj.find((item) => item.title === "hamburger"),
        }
      : null;

  const homePageMenuItems = get(menuItemsObject, ["homePageMenuItems", "children"], []);

  return (
    <div styleName="base" className={`${sticky ? "sticky-palo-navbar" : ""}`} ref={scrollRef}>
      <Headroom>
        <div styleName="header-wrapper" className="logo-ham-search">
          <div styleName={`logo ${isVerticalMenubar ? "vertical-menu-bar-logo" : ""}`}>
            {logoRenderer(
              <DesktopLogo
                location={location}
                lang={publisherAttributes.lang}
                datatrackingcategory="Logo"
                datatrackingaction="Click"
              />,
              "",
              pageType
            )}
          </div>
          <div styleName="login-wrapper" className="print-logo-wrapper">
            <div styleName="search-box">
              {showSearchIcon && (
                <span className="search-icon-wrapper" styleName="search-icon" onClick={toggleSearchIcon}>
                  <SearchIcon color={domainStyle.searchColor} />
                </span>
              )}
              <span ref={ref} styleName={!showSearchIcon ? "navbar-search" : ""}>
                {!showSearchIcon && <NavbarSearch publisherAttributes={publisherAttributes} />}
              </span>
            </div>
          </div>
        </div>
        <div styleName="navbar" className="navbar-wrapper">
          <div styleName="navbar-container">
            <HamburgerIcon
              onMenuToggle={toggleVerticalMenubar}
              isNavbarOpen={isVerticalMenubar}
              isDesktop={isDesktop}
              datatrackingcategory="Button"
              datatrackingaction="Click"
              datatrackinglabel="হ্যামবার্গার বাটন"
            />
            {!isDesktop && <span styleName="menu-text">মেনু</span>}
            {isDesktop && (
              <Navbar
                menu={homePageMenuItems.slice(0, 12)}
                lang={publisherAttributes.lang}
                dataTagCategory="Header Menu"
                toggleVerticalMenubar={() => setDateParams("")}
              />
            )}
          </div>
        </div>
      </Headroom>
    </div>
  );
};

StaticHeader.propTypes = {
  toggleVerticalMenubar: func,
  isVerticalMenubar: bool,
  location: string,
  getIsDesktop: bool,
  domainSlug: string,
  publisherAttributes: object,
  domainMenuItemsObj: array,
  pageType: string,
  socialLinks: object,
  customSocialLinks: object,
  setDateParams: func,
};

const mapStateToProps = (state) => ({
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
  domainMenuItemsObj: get(state, ["qt", "data", "navigationMenu", "prothomaloMenuItems"], []),
  domainSlug: get(state, ["qt", "config", "domainSlug"], ""),
  pageType: get(state, ["qt", "pageType"], ""),
  socialLinks: get(state, ["qt", "config", "social-links"], {}),
  customSocialLinks: get(state, ["qt", "config", "custom-social-links"], {}),
});

const mapDispatchToProps = (dispatch) => ({
  setDateParams: (date) => dispatch(setDateParams(date)),
});

export default connect(mapStateToProps, mapDispatchToProps)(StaticHeader);
